export default {
  NOTIFICATION_SETTINGS: {
    TITLE: `My Notification Settings`,
    SUMMARY: `The following settings control who is to receive email notification given a specific event. Some notification types allow you the choice of being contacted by SMS instead of email.`
  },
  NOTIFICATION_METHOD: `Notification method`,
  REMINDERS_MODULE: `Reminders module`,
  ATTENDANCE_MODULE: `Attendance module`,
  TIMEOFF_MODULE: `Timeoff module`,
  VACATION_CHOICES_MODULE: `Vacation choices module`,
  AVAILABILITY_MODULE: `Availability module`,
  PROJECT_MODULE: `Project module`,
  DISABLESHIFTNOTIFICATIONS: {
    LABEL: `Disable shift reminders`,
    DESCRIPTION: `Shift reminders are normally sent out in the evening for the next day's shifts.`
  },
  DISABLEAVAILABILITIESCUTOFFDATEREMINDER: {
    LABEL: `Disable reminders for submission cutoff of availabilities`,
    DESCRIPTION: `The reminders for submission cutoff of availabilities are sent 3 to 4 hours before the cutoff time.`
  },
  OPTIONS: {
    none: `None`,
    me: `Me`,
    team: `Teams`,
    project: `Projects`,
    teamAndProject: `Teams & Projects`,
    all: `All`,
    email: `Email`,
    sms: `SMS`
  },
  NOTIFICATION_CATEGORIES: {
    create: `Created`,
    update: `Updated`,
    delete: `Deleted`,
    daytodayChanges: `Day-to-day employee changes`
  },
  NOTIFICATION_DESCRIPTIONS: {
    PROJECT_MODULE: {
      daytodayChanges: `As a project owner, you will receive a list of employees that have been added to or removed from your project since yesterday.`
    }
  }
}
